import { type JwtPayload } from 'jwt-decode';

import { User } from '@/core/graphql/generated/types';

export interface AuthState {
	resetStore: () => void;
	idToken: string | null;
	setIdToken: (token: string | null) => void;
	authUsername: string | null;
	setAuthUsername: (username: string | null) => void;
	jwtPayload: AuthPayload | null;

	currentUser: User | null;
	setCurrentUser: (currentUser: User | null) => void;

	clearAuthStore: () => void;
}

export interface AuthPayload extends JwtPayload {
	'cognito:username': string;
	'custom:company_uuid': string;
	origin_jti: string;
	token_use: string;
	auth_time: number;
	'custom:auth_challenge': string;
	'custom:permissions': string; // Note (Ben): This is a comma seperated list of Permission
	email: string;
}

export enum Permission {
	SearchDownload = 'viewer:search_download',
	UsEmails = 'viewer:email_view',
	DcrEnabled = 'dcrEnabled'
}
